import type { Plugin } from 'vue'
import { match } from 'ts-pattern'
import { usePlatform } from '../composables/helpers/platform'
import { PlatformName } from '../composables/helpers/platform/types'
import '../assets/scss/restricted/plugins/scrollbar.scss'

const CUSTOM_SCROLLBAR_CLASS = 'ds-custom-scrollbar'

export const configureScrollbar: Plugin = {
  install: (): void => {
    const { getPlatformName } = usePlatform()

    const shouldApplyCustomScrollbar = match(getPlatformName())
      .with(PlatformName.WINDOWS, PlatformName.LINUX, () => true)
      .otherwise(() => false)

    if (shouldApplyCustomScrollbar) {
      document.documentElement.classList.add(CUSTOM_SCROLLBAR_CLASS)
    }
  },
}
